import { render, staticRenderFns } from "./InteractiveBiography.vue?vue&type=template&id=5a3cd8e6&scoped=true&"
import script from "./InteractiveBiography.vue?vue&type=script&lang=js&"
export * from "./InteractiveBiography.vue?vue&type=script&lang=js&"
import style0 from "./InteractiveBiography.vue?vue&type=style&index=0&id=5a3cd8e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3cd8e6",
  null
  
)

export default component.exports